<template>
  <div class="page p-home p-oversight">
    <menu-item></menu-item>

    <div class="color-bg pure-g">
      <div class="part orange pure-u-1-1 pure-u-md-1-2">
        <div class="color-box">
          <div class="icon p-1-ill-right"></div>
          <h2>{{ $lang.part_1 }}</h2>
          <h4 v-html="$lang.p_over_header_p_1"></h4>
          <div ref="nextBtnTwo" class="btn arrow" v-touch:tap="goTo('Improvement')">
            <p>{{ $lang.start }}</p>
          </div>
          <div class="column-wrapper" v-html="$lang.p_1_right_txt"></div>
        </div>
      </div>
      <div class="part maroon pure-u-1-1 pure-u-md-1-2">
        <div class="color-box">
          <div class="icon p-1-ill-left"></div>
          <h2>{{ $lang.part_2 }}</h2>
          <h4 v-html="$lang.p_over_header_p_2"></h4>
          <div ref="nextBtnOne" class="btn arrow" v-touch:tap="goTo('Dementia')">
            <p>{{ $lang.start }}</p>
          </div>
          <div class="column-wrapper" v-html="$lang.p_1_left_txt"></div>
        </div>
      </div>
      <!-- <div class="part-3 pure-u-1 pure-u-md-1">
        <div class="color-box blue">
          <div class="box-content">
          <h2>{{ $lang.part_3 }}</h2>
          <h4 v-html="$lang.p_over_header_p_3"></h4>
          <div ref="nextBtnOne" class="btn arrow" v-touch:tap="goTo('Studiematerial')">
            <p>{{ $lang.start }}</p>
          </div>
          </div>
        </div>
      </div> -->
      <div class="part-3 part pure-u-1 pure-u-md-1">
        <div class="color-box blue">
          <div class="box-content">
          <h2>{{ $lang.part_3 }}</h2>
          <h4 v-html="$lang.p_over_header_p_3"></h4>
          <div ref="nextBtnOne" class="btn arrow" v-touch:tap="goTo('Material')">
            <p>{{ $lang.start }}</p>
          </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import Menu from '../../../components/menu'

export default {
  name: 'page-home',
  data () {
    return {
      overlay: false
    }
  },
  beforeMount () {
    this.$root.shared.currentPage = 'Oversight'
  },
  methods: {
    setLowestBtn () {
      let first = this.$refs.nextBtnOne.offsetTop
      let second = this.$refs.nextBtnTwo.offsetTop
      let extraMargin = (first > second) ? (first - second) : (second - first)

      if (first > second && extraMargin < 200) {
        this.$refs.nextBtnTwo.style = ('margin-top: ' + (extraMargin + 16) + 'px;')
      } else if (second > first && extraMargin < 200) {
        this.$refs.nextBtnOne.style = ('margin-top: ' + (extraMargin + 16) + 'px;')
      }
    },
    toggleOverlay () {
      let self = this
      return self.onToggleOverlay()
    },
    onToggleOverlay () {
      this.overlay = !this.overlay
    },
    goTo (to) {
      let self = this
      return () => {
        self.onGoTO(to)
      }
    },
    onGoTO (to) {
      this.$router.push({name: to})
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setLowestBtn)
  },
  components: {
    'menu-item': Menu
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/oversight/index.vue